(() => {
  if (window.fcProductLightboxV3Installed) return;

  window.fcProductLightboxV3Installed = true;

  const modalSelector =
    'product-modal.fc-product-lightbox';

  function getMediaItems(modal) {
    const content = modal.querySelector(
      '.product-media-modal__content'
    );

    if (!content) return [];

    return Array.from(content.children).filter(
      (item) => item.hasAttribute('data-media-id')
    );
  }

  function selectMedia(modal, mediaId) {
    if (!modal || !mediaId) return;

    const items = getMediaItems(modal);

    const selected = items.find(
      (item) =>
        item.getAttribute('data-media-id') ===
        String(mediaId)
    );

    if (!selected) return;

    items.forEach((item) => {
      const isSelected = item === selected;

      item.classList.toggle('active', isSelected);
      item.hidden = !isSelected;

      item.style.setProperty(
        'display',
        isSelected ? 'block' : 'none',
        'important'
      );

      if (!isSelected) {
        item.querySelectorAll('video').forEach(
          (video) => video.pause()
        );

        item.querySelectorAll('iframe').forEach(
          (iframe) => {
            iframe.contentWindow?.postMessage(
              JSON.stringify({
                event: 'command',
                func: 'pauseVideo',
                args: []
              }),
              '*'
            );

            iframe.contentWindow?.postMessage(
              JSON.stringify({
                method: 'pause'
              }),
              '*'
            );
          }
        );
      }
    });

    modal.querySelectorAll(
      '[data-fc-media-id]'
    ).forEach((button) => {
      button.setAttribute(
        'aria-pressed',
        String(
          button.dataset.fcMediaId === String(mediaId)
        )
      );
    });

    const deferredMedia = selected.matches(
      'deferred-media, product-model'
    )
      ? selected
      : selected.querySelector(
          'deferred-media, product-model'
        );

    if (
      deferredMedia &&
      typeof deferredMedia.loadContent === 'function'
    ) {
      deferredMedia.loadContent(false);
    }

    const content = modal.querySelector(
      '.product-media-modal__content'
    );

    content.scrollTop = 0;
    content.scrollLeft = 0;
  }

  function filterThumbnails(modal) {
    const sectionId = modal.id.replace(
      'ProductModal-',
      ''
    );

    const gallery = document.getElementById(
      `MediaGallery-${sectionId}`
    );

    if (!gallery) return;

    const visibleIds = new Set();

    gallery.querySelectorAll(
      '.product__media-list > [data-media-id]'
    ).forEach((slide) => {
      const styles = window.getComputedStyle(slide);

      if (
        slide.hidden ||
        styles.display === 'none' ||
        styles.visibility === 'hidden'
      ) {
        return;
      }

      const prefix = `${sectionId}-`;
      const id = slide.dataset.mediaId;

      visibleIds.add(
        id.startsWith(prefix)
          ? id.slice(prefix.length)
          : id
      );
    });

    if (!visibleIds.size) return;

    modal.querySelectorAll(
      '[data-fc-media-id]'
    ).forEach((button) => {
      const visible = visibleIds.has(
        button.dataset.fcMediaId
      );

      button.hidden = !visible;

      button.style.setProperty(
        'display',
        visible ? 'block' : 'none',
        'important'
      );
    });
  }

  function prepareModals() {
    document.querySelectorAll(
      modalSelector
    ).forEach((modal) => {
      modal.showActiveMedia = function () {
        filterThumbnails(this);

        const mediaId = this.openedBy?.getAttribute(
          'data-media-id'
        );

        const fallback = this.querySelector(
          '[data-fc-media-id]:not([hidden])'
        );

        selectMedia(
          this,
          mediaId || fallback?.dataset.fcMediaId
        );
      };
    });
  }

  window.addEventListener(
    'pointerup',
    (event) => {
      const target = event.target;

      if (!(target instanceof Element)) return;

      const thumbnail = target.closest(
                'product-modal.fc-product-lightbox [data-fc-media-id], product-modal.fc-product-lightbox .fc-lightbox-arrow'
      );

      if (!thumbnail) return;

      event.stopImmediatePropagation();
    },
    true
  );
  
  window.addEventListener(
    'click',
    (event) => {
      const target = event.target;

      if (!(target instanceof Element)) return;

            const arrow = target.closest(
        `${modalSelector} .fc-lightbox-arrow`
      );

      if (arrow) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const modal = arrow.closest(modalSelector);

        if (modal.classList.contains('fc-is-zoomed')) return;

        const thumbnails = Array.from(
          modal.querySelectorAll('[data-fc-media-id]')
        ).filter((button) => {
          return (
            !button.hidden &&
            getComputedStyle(button).display !== 'none'
          );
        });

        if (thumbnails.length < 2) return;

        const active = getMediaItems(modal).find(
          (item) => item.classList.contains('active')
        );

        let current = thumbnails.findIndex(
          (button) =>
            button.dataset.fcMediaId === active?.dataset.mediaId
        );

        if (current < 0) current = 0;

        const direction = arrow.classList.contains(
          'fc-lightbox-arrow--prev'
        ) ? -1 : 1;

        const nextIndex =
          (current + direction + thumbnails.length) %
          thumbnails.length;

        selectMedia(
          modal,
          thumbnails[nextIndex].dataset.fcMediaId
        );

        return;
      }

      const thumbnail = target.closest(
        `${modalSelector} [data-fc-media-id]`
      );

      if (thumbnail) {
        if (thumbnail.hidden) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        selectMedia(
          thumbnail.closest(modalSelector),
          thumbnail.dataset.fcMediaId
        );

        return;
      }

      const opener = target.closest(
        'modal-opener'
      );

      if (opener) {
        prepareModals();
      }
    },
    true
  );

  

  customElements.whenDefined(
    'product-modal'
  ).then(prepareModals);

  document.addEventListener(
    'shopify:section:load',
    prepareModals
  );
})();